var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useContext, useMemo, } from 'react';
import { get } from 'lodash';
import { ClickAwayListener, Paper, Popper } from '@material-ui/core';
import { NotificationList, NotifyAvatar } from '@michelin/acid-components';
import { NotificationClient } from './NotificationClient';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { loggerError } from '../../helpers/Log';
import { useStyles } from '../../styles/notificationStyles';
import { useGetNotifications, useUpdateAllNotifications, useUpdateNotification } from '../../helpers/notificationAPI';
export var NotificationButton = function () {
    var _a = useContext(CentralProviderContext), application = _a.application, centralProfile = _a.centralProfile, currentLanguage = _a.currentLanguage;
    var classes = useStyles();
    var _b = useGetNotifications(application), notifications = _b.data, refetch = _b.refetch;
    var refetchNotifications = function () {
        refetch();
    };
    var successCallback = function () { return refetchNotifications(); };
    var updateNotificationMutateAsync = useUpdateNotification(successCallback).mutateAsync;
    var updateAllNotificationsMutateAsync = useUpdateAllNotifications(successCallback).mutateAsync;
    useEffect(function () {
        refetchNotifications();
    }, [application]);
    useEffect(function () {
        var id = setInterval(refetchNotifications, 1000 * 60 * 3);
        return function () {
            clearInterval(id);
        };
    }, []);
    var handleRead = function (notificationId, userId, s, viewed) { return __awaiter(void 0, void 0, void 0, function () {
        var action, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    action = 'read';
                    if (s === 'deleted') {
                        action = 'delete';
                    }
                    else if (viewed === false && s === 'viewed') {
                        action = 'unread';
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateNotificationMutateAsync({
                            user_id: userId,
                            notification_id: notificationId,
                            action: action,
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    loggerError(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleAll = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateAllNotificationsMutateAsync({
                            user_id: centralProfile.uid,
                            action: action,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    loggerError(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _c = __read(React.useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    var data = (notifications || {}).data || [];
    if (!Array.isArray(data))
        data = [];
    var renderNotifications = useMemo(function () { return data.map(function (n) {
        var _a, _b, _c, _d;
        return ({
            _id: get(n, '_id'),
            userId: get(n, 'user_id'),
            tenantId: get(n, 'tenant_id'),
            notifiableId: get(n, 'notifiable_id'),
            notifiableType: get(n, 'notifiable_type'),
            message: {
                html: ((_b = (_a = n === null || n === void 0 ? void 0 : n.messages) === null || _a === void 0 ? void 0 : _a.find((function (msg) { return (msg === null || msg === void 0 ? void 0 : msg.lang) === currentLanguage; }))) === null || _b === void 0 ? void 0 : _b.html) || get(n, 'messages.0.html'),
                text: ((_d = (_c = n === null || n === void 0 ? void 0 : n.messages) === null || _c === void 0 ? void 0 : _c.find((function (msg) { return (msg === null || msg === void 0 ? void 0 : msg.lang) === currentLanguage; }))) === null || _d === void 0 ? void 0 : _d.text) || get(n, 'messages.0.text'),
            },
            createdAt: get(n, 'createdAt'),
            updatedAt: get(n, 'updatedAt'),
            viewedAt: get(n, 'readAt') || '',
            deletedAt: get(n, 'deletedAt') || '',
        });
    }); }, [data, currentLanguage]);
    var unreadNotifications = data.filter(function (n) { return !n.readAt; });
    return (React.createElement("span", null,
        React.createElement(NotifyAvatar, { icon: "notifications", color: data.length < 1 ? 'default' : 'primary', badgeContent: unreadNotifications.length, badgeColor: "danger", onClick: handleClick }),
        React.createElement(Popper, { anchorEl: anchorEl, placement: "bottom", open: Boolean(anchorEl) },
            React.createElement(ClickAwayListener, { mouseEvent: "onMouseDown", onClickAway: handleClose },
                React.createElement(Paper, { className: classes.paper, elevation: 6 },
                    React.createElement(NotificationList, { notifications: renderNotifications, onUpdate: function (n, action, value) {
                            handleRead(n._id, n.userId, action, value);
                        }, onReadAllClick: function () {
                            handleAll('readAll');
                        }, onDeleteAllClick: function () {
                            handleAll('deleteAll');
                        } })))),
        React.createElement(NotificationClient, null)));
};
//# sourceMappingURL=NotificationButton.js.map